import { Route, Routes } from 'react-router-dom';

import { paths } from 'data/routes';

import { TabType } from 'components/Tabs';

import { Data } from './components/Data';
import { List } from './components/List';
import { Manage } from './components/Manage';
import { RelatedProducts } from './components/RelatedProducts';

export function Notifications(): React.ReactElement {
  const newTabs: TabType[] = [{ id: 1, title: 'Data', content: <Data /> }];

  const editTabs: TabType[] = [
    { id: 1, title: 'Data', content: <Data /> },
    { id: 2, title: 'Related Products', content: <RelatedProducts /> },
  ];

  return (
    <Routes>
      <Route path="/">
        <Route index element={<List />} />
        <Route
          path={`${paths.manage}/:id`}
          element={<Manage title="Notifications" tabs={editTabs} />}
        />
        <Route
          path={paths.add}
          element={<Manage title="Add new notification" tabs={newTabs} isNew />}
        />
      </Route>
    </Routes>
  );
}
